var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"dashboard-container container--fluid"},[_c('countries-grid')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }